import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="add-to-calendar"
// Click-toggle dropdown for the "Add to Calendar" options on the order
// confirmation. Closes on outside click or Escape. Click/tap only (no hover).
export default class extends Controller {
  static targets = ["button", "menu"]

  connect() {
    this._onDocClick = this.onDocumentClick.bind(this)
    this._onKeydown = this.onKeydown.bind(this)
  }

  disconnect() {
    document.removeEventListener("click", this._onDocClick)
    document.removeEventListener("keydown", this._onKeydown)
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()
    this.menuTarget.hidden ? this.open() : this.close()
  }

  open() {
    this.menuTarget.hidden = false
    this.buttonTarget.setAttribute("aria-expanded", "true")
    document.addEventListener("click", this._onDocClick)
    document.addEventListener("keydown", this._onKeydown)
  }

  close() {
    this.menuTarget.hidden = true
    this.buttonTarget.setAttribute("aria-expanded", "false")
    document.removeEventListener("click", this._onDocClick)
    document.removeEventListener("keydown", this._onKeydown)
  }

  onDocumentClick(event) {
    if (!this.element.contains(event.target)) this.close()
  }

  onKeydown(event) {
    if (event.key === "Escape") this.close()
  }
}
